import React from 'react';
import { groupBy, isEmpty } from 'lodash';
import { Icon, Input, Tree } from 'antd';
import { HIDDEN_COLUMNS } from '../../constants/grid.constants';
import {
  MenuItem, SideMenuWrapper, SubMenu, MenuSearchWrapper, BottomMenuWrapper, SplitPanel,
} from './styles';

const formatItems = (menuItems, menuSearch) => {
  const noChildren = items => items
    .filter(({ is_child }) => !is_child)
    .filter(({ data_group }) => data_group)
    .filter(({ item_display_name }) => item_display_name.toLowerCase().match(menuSearch));

  const grouping = items => groupBy(items, 'data_group');

  const renderable = groups => Object.keys(groups)
    .map(group => ({
      group, items: groups[group],
    }));

  return renderable(grouping(noChildren(menuItems)));
};

const editableIcon = editable => editable
  ? <Icon type="unlock" />
  : <Icon theme="filled" type="lock" />;

const generateColumnTree = (menuItems = [], selectedKeys = []) => selectedKeys
  .map((key) => {
    const activeItem = menuItems.find(item => (item.item_type === key));
    if (!activeItem) return '';
    return (
      <Tree.TreeNode
        title={<b>{activeItem.item_display_name}</b>}
        key={key}
      >
        {activeItem.columns
          .filter(column => (!HIDDEN_COLUMNS.includes(column.name)))
          .map(column => (
            <Tree.TreeNode
              title={column.display_name}
              key={`${key}-${column.name}`}
            />
          ))
        }
      </Tree.TreeNode>
    );
  });

const determineChecked = (menuItems = [], selectedKeys = [], unCheckList = []) => selectedKeys
  .reduce((acc, currKey) => {
    const activeItem = menuItems.find(item => (item.item_type === currKey));
    if (!activeItem) return [];
    return acc.concat(
      activeItem.columns
        .filter(column => (!HIDDEN_COLUMNS.includes(column.name)))
        .map(column => (`${currKey}-${column.name}`)),
    );
  }, [])
  .filter(column => (!unCheckList.includes(column)));

const makeHideColumnsList = (fullList = [], shownList = []) => ({
  removeFromHideList: shownList,
  addToHideList: fullList.filter(column => (!shownList.includes(column))),
});

const SideMenu = ({
  persistParams, menuItems, selectedKeys, extras, menuSearch, btmHeight,
  onCheckToToggleColumns, onKeyMenuSearch, onChangeSideBarSplitSize, ...props
}) => {
  const checkedKeys = determineChecked(menuItems, selectedKeys, persistParams.dataPageHideColumns);
  const topPaneSize = (persistParams && persistParams.dataPageSideBarSplitPaneSize)
    ? persistParams.dataPageSideBarSplitPaneSize
    : '70%';

  return (
    <>
      <MenuSearchWrapper>
        <Input.Search
          placeholder="Menu filter"
          onChange={value => onKeyMenuSearch(value)}
        />
      </MenuSearchWrapper>
      <SplitPanel
        split="horizontal"
        defaultSize={topPaneSize}
        minSize={290}
        maxSize={-290} // Assigning a negative value sets maxSize from bottom.
        onDragFinished={onChangeSideBarSplitSize}
      >
        <SideMenuWrapper {...props} mode="inline">
          {!isEmpty(menuItems)
            && formatItems(menuItems, menuSearch)
              .map(({ group, items }) => (
                <SubMenu key={group} title={group}>
                  {items.map(({
                    item_type, item_display_name, editable,
                  }) => (
                    <MenuItem key={item_type}>
                      {editableIcon(editable)}
                      <span>{item_display_name}</span>
                    </MenuItem>
                  ))}
                </SubMenu>
              ))
          }
          <SubMenu key="tools" title="Tools">
            {Object.keys(extras).map(key => (extras[key].name.toLowerCase().match(menuSearch)) && (
              <MenuItem key={key}>
                {extras[key].icon}
                {extras[key].name}
              </MenuItem>
            ))}
          </SubMenu>
        </SideMenuWrapper>
        <BottomMenuWrapper getTopPaneSize={topPaneSize}>
          <div id="DCRPShowHideGridColumnTree">
            <Tree
              checkable
              expandedKeys={selectedKeys}
              checkedKeys={checkedKeys}
              autoExpandParent
              onCheck={checked => onCheckToToggleColumns(
                makeHideColumnsList(checkedKeys, checked),
              )}
            >
              {generateColumnTree(menuItems, selectedKeys)}
            </Tree>
          </div>
        </BottomMenuWrapper>
      </SplitPanel>
    </>
  );
};

export default SideMenu;
